const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  mchtId: state => state.user.parentId || state.user.userId,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  applyCode: state => state.user.applyCode,
  isFirstLogin: state => state.user.isFirstLogin,
  messagenum: state => state.user.messagenum || 0,
  cartnum: state => state.user.cartnum || 0,
  audit: state => state.user.audit,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js